import { render, staticRenderFns } from "./followUpDetail.vue?vue&type=template&id=5ff7de13&scoped=true"
import script from "./followUpDetail.vue?vue&type=script&lang=js"
export * from "./followUpDetail.vue?vue&type=script&lang=js"
import style0 from "./followUpDetail.vue?vue&type=style&index=0&id=5ff7de13&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff7de13",
  null
  
)

export default component.exports